import { useTranslation } from "react-i18next";
import { Dot } from "../svg/AllSvg";

const PageRoot = ({ page, subPage }: any) => {
    const { t } = useTranslation('common');

    return (
        <div className="px-[18px] xlsm:px-[25px] xlx:px-[45px] w-full flex items-center justify-center mt-[-8px]">
            <div className="w-[1200px] xlx:w-[1384px]">
                <div className="px-[15px] md:px-[30px] xl:pt-[26px] xl:pb-[18px] pt-[18px] pb-[10px] sm:pt-[20px] sm:pb-[12px] bg-[#F5F5F5] dark:bg-[#3c3e49] rounded-b-[8px] xlsm:rounded-b-[10px] xl:rounded-b-[20px] flex items-center gap-[8px] md:gap-[10px] w-full flex-wrap">
                    <h5 className="text-[#6C757D] dark:text-textBlackDark font-medium whitespace-nowrap">{t("recruitment.home.home")}</h5>
                    <div className="min-w-[6px]">
                        <Dot className="fill-[#6C757D] dark:fill-textBlackDark" />
                    </div>
                    <h5 className="text-[#6C757D] dark:text-textBlackDark font-medium whitespace-nowrap">{page}</h5>
                    {!!subPage && <>
                        <div className="min-w-[6px]">
                            <Dot className="fill-[#6C757D] dark:fill-textBlackDark" />
                        </div>
                        <h5 className="text-[#6C757D] dark:text-textBlackDark font-medium whitespace-nowrap">{subPage}</h5>
                    </>}
                </div>
            </div>
        </div>
    );
};

export default PageRoot;